<mat-card class="accion-emergencia-dialog importar-emergencias">
  <app-card-header
    title="Importar emergencias"
    subtitle="Cargá emergencias ya cerradas desde un archivo CSV"
  ></app-card-header>
  <mat-divider></mat-divider>

  <mat-card-content class="card-content-crear cardContentDialog">
    @if (resultado) {
      <!-- Resultado -->
      <app-content-card
        title="Resultado"
        icon="fact_check"
        [color]="resultado.errores.length ? 'orange' : 'green'"
      >
        <section class="inputs-group">
          <div class="importar-resumen">
            <div class="importar-numero">
              <span class="valor">
                {{ resultado.creadas.toLocaleString('es-AR') }}
              </span>
              <span class="etiqueta">importadas</span>
            </div>
            <div
              class="importar-numero"
              [class.con-errores]="resultado.errores.length"
            >
              <span class="valor">
                {{ resultado.errores.length.toLocaleString('es-AR') }}
              </span>
              <span class="etiqueta">con error</span>
            </div>
            <div class="importar-numero">
              <span class="valor">
                {{ resultado.total.toLocaleString('es-AR') }}
              </span>
              <span class="etiqueta">en el archivo</span>
            </div>
          </div>
        </section>
        @if (resultado.erroresPorLinea.length) {
          <section class="inputs-group">
            <div class="importar-errores">
              @for (e of resultado.erroresPorLinea; track $index) {
                <div class="importar-error">
                  <span class="linea">Línea {{ e.linea }}</span>
                  <span>{{ e.error }}</span>
                </div>
              }
            </div>
          </section>
        }
      </app-content-card>
    } @else {
      <!-- Formato -->
      <app-info-banner
        icon="info"
        color="blue"
        [closable]="false"
        [collapsible]="true"
        [expanded]="true"
        title="Las emergencias importadas sirven para las métricas del tablero"
        message="Se crean ya finalizadas (o canceladas, si la columna Cancelado dice verdadero) y no aparecen en Auxilios ni En seguimiento: las ves en Histórico con la situación Importada."
      ></app-info-banner>

      <app-content-card
        title="Formato del archivo"
        icon="table_chart"
        color="purple"
      >
        <section class="inputs-group">
          <div class="importar-formato">
            <p>
              Una emergencia por línea, con
              <strong>20 columnas</strong>
              separadas por
              <strong>punto y coma (;)</strong>
              , en este orden:
            </p>
            <ol class="importar-columnas">
              @for (c of columnas; track c; let i = $index) {
                <li>
                  <span class="numero">{{ i + 1 }}</span>
                  {{ c }}
                </li>
              }
            </ol>
            <ul class="importar-reglas">
              <li>
                <strong>Fechas</strong>
                (columnas 16 a 20): dd/mm/aaaa hh:mm:ss, por ejemplo 15/03/2026
                14:30:00. Pueden quedar vacías.
              </li>
              <li>
                <strong>Códigos</strong>
                (columnas 3 y 9):
                <span class="importar-codigos">
                  @for (c of codigos; track c.label) {
                    <span class="em-badge" [style.--c]="c.color">
                      {{ c.label.toUpperCase() }}
                    </span>
                  }
                </span>
                El de cierre es opcional: si falta, se usa el de apertura.
              </li>
              <li>
                <strong>Cancelado y Reasignada</strong>
                (columnas 10 y 11): verdadero o falso (también sí/no). Vacío
                cuenta como falso.
              </li>
              <li>
                Las columnas 4 a 8 y 12 a 15 se leen pero no se guardan; la
                columna 1 (Servicio) queda en las observaciones.
              </li>
            </ul>
          </div>
        </section>
      </app-content-card>

      <!-- Contenido -->
      <app-content-card title="Contenido" icon="upload_file" color="green">
        <section class="inputs-group">
          <div class="importar-carga">
            <input
              #archivo
              type="file"
              accept=".csv,.txt"
              hidden
              (change)="cargarArchivo($event)"
            />
            <app-button
              matType="mat-fab extended"
              color="primary"
              icon="folder_open"
              text="Elegir archivo CSV"
              (click)="archivo.click()"
            ></app-button>
            <mat-checkbox
              color="primary"
              [(ngModel)]="primeraLineaEncabezado"
              (ngModelChange)="revalidar()"
            >
              La primera línea es el encabezado (se omite)
            </mat-checkbox>
          </div>
        </section>
        <section class="inputs-group">
          <mat-form-field style="width: 100%">
            <mat-label>O pegá el contenido acá</mat-label>
            <textarea
              matInput
              [formControl]="csv"
              rows="10"
              class="importar-textarea"
              placeholder="1001;15/03/2026;VERDE;14:30:00;14:35:00;14:50:00;;15:20:00;AMARILLO;falso;falso;;;;;15/03/2026 14:30:00;15/03/2026 14:35:00;15/03/2026 14:50:00;;15/03/2026 15:20:00"
            ></textarea>
            @if (csv.value && csv.valid) {
              <mat-hint>
                {{ cantidadLineas.toLocaleString('es-AR') }}
                {{
                  cantidadLineas === 1
                    ? 'emergencia lista'
                    : 'emergencias listas'
                }}
                para importar
              </mat-hint>
            }
            @if (csv.hasError('error')) {
              <mat-error>{{ csv.getError('error') }}</mat-error>
            }
          </mat-form-field>
        </section>
      </app-content-card>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    @if (resultado) {
      <app-button
        matType="mat-fab extended"
        color="neutral"
        text="Importar otro archivo"
        icon="upload_file"
        (click)="otraImportacion()"
      ></app-button>
      <app-button
        matType="mat-fab extended"
        color="primary"
        text="Listo"
        icon="check"
        (click)="cerrar()"
      ></app-button>
    } @else {
      <app-button
        matType="mat-fab extended"
        color="neutral"
        text="Cancelar"
        icon="close"
        (click)="cerrar()"
      ></app-button>
      <app-button
        matType="mat-fab extended"
        color="primary"
        text="Importar"
        icon="upload_file"
        [disabled]="csv.invalid || importando"
        [loading]="importando"
        (click)="importar()"
      ></app-button>
    }
  </mat-card-actions>
</mat-card>
